export default {
  vision_blog: "vision blog".toUpperCase(),
  stay_turned_for__: "Stay tuned for everything happening on Vision.".toUpperCase(),
  all: "all".toUpperCase(),
  articles: "articles".toUpperCase(),
  show_more: "show more".toUpperCase(),
};
